import { Component, Input, OnInit } from '@angular/core';
import { ComponentName } from 'src/app/models/enums';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { IRegion } from 'src/app/models/sportHierarchy/region';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { SportsService } from 'src/app/services/sports.service';

@Component({
  selector: 'app-sports-tree-breadcrumbs',
  templateUrl: './sports-tree-breadcrumbs.component.html',
  styleUrls: ['./sports-tree-breadcrumbs.component.less']
})
export class SportsTreeBreadcrumbsComponent implements OnInit {
  @Input()
  sport: ISport;

  @Input()
  region: IRegion;

  @Input()
  competition: ICompetition;

  constructor(private sportsService: SportsService) { }

  ngOnInit(): void {
  }

  deselectSport(notify: boolean = true) {
    if (this.sport) {
      this.sport.isSelected = false;
      this.sport.showRegions = false;
      if (notify) {
        this.sportsService.selectSportNotify(null, false, ComponentName.SportsTreeBreadcrumbsComponent);
      }
      this.deselectRegion(false);
    }
  }

  deselectRegion(notify: boolean = true) {
    if (this.region && !this.sport.specialOfferType) {
      this.region.isSelected = false;
      this.region.showCompetitions = false;
      if (notify) {
        this.sportsService.selectRegionNotify(null, this.sport, false, ComponentName.SportsTreeBreadcrumbsComponent);
      }
      this.deselectCompetition(false);
    }
  }

  deselectCompetition(notify: boolean = true) {
    if (this.competition) {

      this.competition.isSelected = false;
      if (notify) {
        this.sportsService.selectCompetitionNotify(null, this.region, this.sport, false, ComponentName.SportsTreeBreadcrumbsComponent);
      }
    }
  }

  selectSport() {

  }

  selectRegion() {

  }

  back() {
    if (this.region && !this.sport.specialOfferType) {
      this.deselectRegion();
    } else if (this.sport) {
      this.deselectSport();
    }
  }

}
